import { createContext } from 'react'

type LuxPlusLandingNonMemberTab = 'about' | 'benefits' | 'partner-offers'
type LuxPlusLandingMemberTab = 'best-offers' | 'partner-offers' | 'all-benefits'

const noop = () => {}

interface LuxPlusLandingNavigationContextValue {
  navigateToPartnerOffers: () => void
}

const LuxPlusLandingNavigationContext = createContext<LuxPlusLandingNavigationContextValue>({
  navigateToPartnerOffers: noop,
})

export type { LuxPlusLandingNonMemberTab, LuxPlusLandingMemberTab }
export default LuxPlusLandingNavigationContext
